import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { YoyakuService } from "../service/yoyaku.service";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dayoftheweek-selecter-app',
  templateUrl: './dayoftheweek-selecter.component.html',
  styleUrls: ['dayoftheweek-selecter.component.css']
})

export class DayoftheweekSelecterModalComponent {
  @Input() selected: any[];

  constructor(
    public commonService: CommonService,
    private yoyakuService: YoyakuService,
    public activeModal: NgbActiveModal,
  ) { }

  ret: any = {
    status: "",
    selectedData: [],
  }
  //起動時処理
  ngOnInit(): void {
    this.selected;
  };
  OK(): void {
    this.ret.status = 'OK';
    this.ret.selectedData = this.selected;
    this.activeModal.close(this.ret);
  }
  //キャンセル時
  Cancel() {
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/a2103-yoyaku-register/dayoftheweek-selecter.component.ts